import { Transform } from "class-transformer";
import { IsBoolean, IsOptional } from "class-validator";

export class FindOneBuildProjectDto {
  @IsBoolean()
  @IsOptional()
  @Transform(({ value }) => value === "true")
  includeOverviewImg?: boolean | null;

  @IsBoolean()
  @IsOptional()
  @Transform(({ value }) => value === "true")
  includeAccountManager?: boolean | null;
}
